import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {TokenListComponent} from './token-list.component';
import {IpdTokenListComponent} from './ipd-token-list/ipd-token-list.component';

const routes: Routes = [
    {path: 'tokenlist', component: TokenListComponent},
    {path: 'ipdtokenlist', component: IpdTokenListComponent}
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/token-list/token-list.routing.ts